export enum DynamicProperties {
  Organization = "organization_name",
  Coc = "coc_number",
  Vat = "vat_number",
  Newsletter = "newsletter",
  TemporaryAddress = "temporary_address",
  DeliveryDate = "deliveryDate",
}
